var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"time-table-container"},[_c('DayHeader'),_vm._l((_vm.days),function(day){return _c('Day',{key:day,attrs:{"day":day}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }